import './../AuthPages.scss';
import './LoginPage.scss';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';

import { clearCredentials, login, setCredentials } from 'containers/Auth/store/actions';

import LoginForm from './LoginForm';
import Logo from 'components/Logo'

class LoginPage extends React.Component {
    componentWillMount() {
        document.body.classList.add('auth-page');
    }

    componentWillUnmount() {
        document.body.classList.remove('auth-page');
    }

    handleSubmit(formIsValid) {
        if(formIsValid === true) {
            this.props.login()
                .then((res) => {
                    console.log(res);
                    if(res && res.code < 300) {
                        this.props.changeLocation('/users');
                        this.props.clearCredentials();
                    }
                })
        }
    }

    render() {
        return (
            <div className="auth--wrapper">
                <Logo
                    orientation="horizontal"
                />

                <LoginForm
                    credentials={this.props.auth.credentials}
                    error={this.props.auth.error}
                    isFetching={this.props.auth.isFetching}
                    onValid={this.handleSubmit.bind(this, true)}
                    onInvalid={this.handleSubmit.bind(this, false)}
                    setCredentials={this.props.setCredentials}
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        clearCredentials: () => dispatch(clearCredentials()),
        login: () => dispatch(login()),
        setCredentials: (credentialsObj) => dispatch(setCredentials(credentialsObj))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);



// WEBPACK FOOTER //
// ./src/containers/Auth/LoginPage/index.js